<template>
  <UChip :text="userStore.unreadNotificationCount" :show="userStore.unreadNotificationCount > 0"
         size="3xl" color="success" :ui="{base: 'ring-0 p-1.5'}">
    <UButton :to="notificationPageMoodle" @click="userStore.resetUnreadNotificationCount()"
             class="p-0 bg-transparent hover:bg-transparent transition-transform active:bg-transparent focus:outline-none hover:cursor-pointer group">
      <UIcon name="ph:bell"
             :class="[iconClass, 'w-6 h-6 block group-hover:hidden group-focus:hidden group-active:hidden']"/>
      <UIcon name="ph:bell-fill"
             :class="[iconClass, 'w-6 h-6 hidden group-hover:block group-focus:block group-active:block']"/>
    </UButton>
  </UChip>
  <!--div ref="target" class="relative inline-block" @keydown.esc="menuAberto = false">
      <UButton type="button" @click="menuAberto = !menuAberto"
          class="p-0 bg-transparent hover:bg-transparent transition-transform active:bg-transparent focus:outline-none hover:cursor-pointer group">
          <UIcon name="ph:bell"
              :class="[iconClass, 'w-6 h-6 block group-hover:hidden group-focus:hidden group-active:hidden']" />
          <UIcon name="ph:bell-fill"
              :class="[iconClass, 'w-6 h-6 hidden group-hover:block group-focus:block group-active:block']" />
      </UButton>
      <div v-show="menuAberto"
          class="absolute shadown-lg px-6 py-4 right-0 mt-2 w-80 h-125 bg-white rounded-xl shadow-2xl overflow-hidden z-50 origin-top-right border border-gray-100">
          <div class="flex justify-between items-center mb-4">
              <h3 class="text-lg font-semibold text-gray-800">Notificações</h3>
              <div class="flex justify-between align-center h-full gap-4">
                  <UIcon name="i-ph-check-bold" class="w-5 h-5 text-[#055F00] hover:cursor-pointer" />
                  <UIcon name="i-ph-gear-fill" class="w-5 h-5  text-[#055F00] hover:cursor-pointer" />
              </div>
          </div>
          <USeparator />
          <div class="flex flex-col justify-between h-105">
              <div class="py-6">
                  <span>Você não tem nenhuma notificação</span>
              </div>
              <div class="text-center">
                  <USeparator class="pb-4" />
                  <a href="#">
                      <span>Mostrar todos</span>
                  </a>
              </div>
          </div>
      </div>
  </div-->
</template>
<script setup lang="ts">
const config = useRuntimeConfig()
const notificationPageMoodle = `${config.public.baseURL}/message/output/popup/notifications.php`

import {onClickOutside} from '@vueuse/core'

defineProps({
  iconClass: {
    type: String,
    default: 'text-gray-700' // cor padrão do ícone
  }
})

const userStore = useUserStore()

const menuAberto = ref(false)

//fecha o menu ao clicar fora
const target = ref(null)
onClickOutside(target, () => (menuAberto.value = false))
</script>